import { useEffect } from "react";
import { useLocation } from "react-router";
import { loadPage } from "@core/navigation";
import { NotFoundPage } from "../routes/errors";
import { isAppPath } from "./routes";
import { useHydrated } from "./session";

export const NOT_FOUND_ROUTE_ID = "not-found";

/**
 * A path the visitor's routes have no page for: the 404 page (the links and navigateTo() already send such paths to
 * the server, so this is a page load, Back/Forward or a router navigation). On a page load the server has sent the
 * shell with its own 404 page's frame (SpaController.Error), so, like the server's, it's drawn after hydrating.
 * One exception: an admin page for a visitor whose routes leave it out (routesFor) loads in full, so the server
 * decides; that's someone who became an admin by signing in since the app loaded.
 */
export function NotFound() {
    const location = useLocation();
    const hydrated = useHydrated();
    const isAdminPage = location.key !== "default" && isAppPath(location.pathname);

    useEffect(() => {
        if (isAdminPage)
            loadPage(location.pathname + location.search + location.hash, { replace: true });
    }, [isAdminPage, location]);

    return hydrated && !isAdminPage ? <NotFoundPage /> : null;
}
